import * as React from 'react'
import { Box, Grid, Typography } from '@mui/material'
import { isPdfFile } from '../../../utils/scaffoldReceiptPdf'

type ReceiptAttachmentsProps = {
	files: File[]
	imageUrls: string[]
}

export default function ReceiptAttachments({ files, imageUrls }: ReceiptAttachmentsProps) {
	const pdfFiles = files.filter(isPdfFile)
	const imageFiles = files.filter((file) => !isPdfFile(file))

	return (
		<Grid item xs={12}>
			<Typography variant='subtitle1' sx={{ fontWeight: 'bold', mb: 1, color: 'text.primary' }}>
				📎 Attachments ({files.length})
			</Typography>
			<Box sx={{ pl: 2 }}>
				{pdfFiles.length > 0 && (
					<Box sx={{ mb: 1 }}>
						<Typography variant='body2' sx={{ fontWeight: 'bold', mb: 0.5 }}>
							PDF Documents ({pdfFiles.length}) — included at the end of the receipt
						</Typography>
						{pdfFiles.map((file, index) => (
							<Typography
								key={`${file.name}-${index}`}
								variant='body2'
								sx={{ mb: 0.5, wordBreak: 'break-word' }}
							>
								• {file.name}
							</Typography>
						))}
					</Box>
				)}
				{imageFiles.length > 0 && (
					<Box>
						<Typography variant='body2' sx={{ fontWeight: 'bold', mb: 0.5 }}>
							Images ({imageFiles.length}) — included on the following pages
						</Typography>
						<Box data-receipt-screen-only sx={{ pt: 1 }}>
							<Grid container spacing={1}>
								{imageUrls.map((url, index) => (
									<Grid item xs={6} sm={3} key={url}>
										<Box
											component='img'
											src={url}
											alt={imageFiles[index]?.name}
											sx={{
												width: '100%',
												height: 96,
												objectFit: 'cover',
												borderRadius: 1,
												border: '1px solid',
												borderColor: 'grey.300',
												display: 'block',
											}}
										/>
									</Grid>
								))}
							</Grid>
						</Box>
					</Box>
				)}
			</Box>
		</Grid>
	)
}
